export default "__VITE_ASSET__d164be00__"